import { Editor, EditorContent } from '@tiptap/react';
import React, { useEffect } from 'react';
import './TipTapEditor.scss';

//Source: https://tiptap.dev/examples/tables

export interface ITipTapEditor {
  editor: Editor | null,
  editable: boolean,
  content: string
}
const TipTapEditor: React.FC<ITipTapEditor> = ({ editor, editable, content }) => {

  useEffect(() => {
    if (editor) {
      editor.setOptions({ editable: editable });
      editor.commands.setContent(content);
    }
  }, [editable, content])

  if (editor)
    return (
      <div className='tiptap-editor'>
        <EditorContent editor={editor} />
      </div>
    )
  else
    return <div>Error: No Editor</div>

  // function onBlurHandler({ editor }: any) {
  //   onBlur(editor.getHTML());
  // }
}

export default TipTapEditor;